import Vue from 'vue';

// layouts

import DefaultLayout from '../layouts/Default';
import AdminLayout from '../layouts/Admin';
import HomeLayout from '../layouts/Home';

Vue.component('default-layout', DefaultLayout);
Vue.component('admin-layout', AdminLayout);
Vue.component('home-layout', HomeLayout);

// vee-validate

import { ValidationProvider } from 'vee-validate'
import { ValidationObserver } from 'vee-validate'

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);